"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn";
import { formatCombo } from "../hooks/use-hotkeys";
/** Keycap. Always render shortcuts through this so they read identically everywhere. */
export function Kbd({ combo, className }) {
    return (_jsx("kbd", { className: cn("inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded border border-line px-1.5", "bg-surface-sunken font-mono text-[0.6875rem] font-medium text-content-secondary", "shadow-[inset_0_-1px_0_0_hsl(var(--line-default))]", className), children: formatCombo(combo) }));
}
//# sourceMappingURL=kbd.js.map